module.exports = __webpack_public_path__ + "img/10.731ed3fd.jpg";